export default [
  { path: '/base/role', name: 'BaseRole', component: () => import(/* webpackChunkName: "base-role" */ './index.vue') }
]